import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { __awaiter } from 'tslib';
import { Router } from '@angular/router';
import { LoyaltyLimitType, TermsAndCondtion, config, ItemLoyaltyState, ErrorStateService, LottoService, LottoQuery, BalanceService, TransactionSuccessService, BalanceQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { take } from 'rxjs/operators';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { NumberInputModule } from '@fgb/portal-component-library/src/lib/shared/number-input';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { ConfirmModalTermsModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal-terms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/shared/errors';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/shared/countdown';
import * as ɵngcc8 from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import * as ɵngcc9 from '@fgb/portal-component-library/src/lib/shared/number-input';
import * as ɵngcc10 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc11 from '@ngx-translate/core';

function LottoDetailsComponent_div_0_div_2_span_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r3.lottoItem.NumberOfTicketsPurchased, " Entry");
} }
function LottoDetailsComponent_div_0_div_2_span_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r4.lottoItem.NumberOfTicketsPurchased, " Entries");
} }
function LottoDetailsComponent_div_0_div_2_ng_container_31_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "fgbcl-number-input", 29);
    ɵngcc0.ɵɵlistener("amountChange", function LottoDetailsComponent_div_0_div_2_ng_container_31_div_1_Template_fgbcl_number_input_amountChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(4); return ctx_r10.entries = $event; });
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const limitMessage_r9 = ctx.ngSubscribe;
    const entriesLimit_r2 = ɵngcc0.ɵɵnextContext(2).ngSubscribe;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("isActive", ctx_r8.available)("amount", ctx_r8.entries)("minValue", entriesLimit_r2 > 0 ? 1 : 0)("maxValue", entriesLimit_r2)("incrementValue", 1)("minMessage", "1 minimum")("maxMessage", ɵngcc0.ɵɵpipeBind1(2, 7, limitMessage_r9));
} }
function LottoDetailsComponent_div_0_div_2_ng_container_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, LottoDetailsComponent_div_0_div_2_ng_container_31_div_1_Template, 3, 9, "div", 27);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSubscribe", ctx_r5.limitMessage$);
} }
function LottoDetailsComponent_div_0_div_2_ng_template_42_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 30);
    ɵngcc0.ɵɵelementStart(1, "b", 31);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hr", 32);
    ɵngcc0.ɵɵelementStart(5, "div", 33);
    ɵngcc0.ɵɵelementStart(6, "div", 34);
    ɵngcc0.ɵɵelement(7, "img", 35);
    ɵngcc0.ɵɵpipe(8, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 36);
    ɵngcc0.ɵɵelementStart(10, "div", 37);
    ɵngcc0.ɵɵelementStart(11, "div", 38);
    ɵngcc0.ɵɵelementStart(12, "div", 39);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 37);
    ɵngcc0.ɵɵelementStart(15, "div", 40);
    ɵngcc0.ɵɵelementStart(16, "div", 41);
    ɵngcc0.ɵɵelementStart(17, "span", 42);
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵpipe(19, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "span");
    ɵngcc0.ɵɵtext(21);
    ɵngcc0.ɵɵpipe(22, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 40);
    ɵngcc0.ɵɵelementStart(24, "div", 43);
    ɵngcc0.ɵɵelementStart(25, "span", 42);
    ɵngcc0.ɵɵtext(26);
    ɵngcc0.ɵɵpipe(27, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "span");
    ɵngcc0.ɵɵtext(29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 10, "lotto.confirm.text"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind3(8, 12, ctx_r7.lottoItem.ImageName, "7", "lotto"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("alt", ctx_r7.lottoItem.ImageName);
    ɵngcc0.ɵɵproperty("useDefault", true)("loyaltyType", "lotto");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.lottoItem.Title);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(19, 16, "lotto.points.value"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(22, 18, ctx_r7.lottoItem.PurchasePrice * ctx_r7.entries), "");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(27, 20, "lotto.entries"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.entries, "");
} }
function LottoDetailsComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "img", 5);
    ɵngcc0.ɵɵpipe(3, "contentImage");
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelement(5, "fgbcl-loyalty-icon", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵelementStart(7, "h2", 9);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 10);
    ɵngcc0.ɵɵelementStart(10, "div", 11);
    ɵngcc0.ɵɵelementStart(11, "div", 12);
    ɵngcc0.ɵɵelementStart(12, "span", 13);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵtext(14, "emoji_events");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "span", 14);
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵpipe(17, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 12);
    ɵngcc0.ɵɵelementStart(19, "span", 13);
    ɵngcc0.ɵɵpipe(20, "translate");
    ɵngcc0.ɵɵtext(21, "confirmation_number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(22, LottoDetailsComponent_div_0_div_2_span_22_Template, 2, 1, "span", 15);
    ɵngcc0.ɵɵtemplate(23, LottoDetailsComponent_div_0_div_2_span_23_Template, 2, 1, "span", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 12);
    ɵngcc0.ɵɵelementStart(25, "span", 13);
    ɵngcc0.ɵɵpipe(26, "translate");
    ɵngcc0.ɵɵtext(27, "schedule");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "fgbcl-countdown", 16);
    ɵngcc0.ɵɵlistener("complete", function LottoDetailsComponent_div_0_div_2_Template_fgbcl_countdown_complete_28_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.lottoEnd(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "div", 17);
    ɵngcc0.ɵɵelementStart(30, "div", 18);
    ɵngcc0.ɵɵtemplate(31, LottoDetailsComponent_div_0_div_2_ng_container_31_Template, 2, 1, "ng-container", 19);
    ɵngcc0.ɵɵelementStart(32, "div", 20);
    ɵngcc0.ɵɵelementStart(33, "button", 21);
    ɵngcc0.ɵɵlistener("confirm", function LottoDetailsComponent_div_0_div_2_Template_button_confirm_33_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.enterLotto(); });
    ɵngcc0.ɵɵtext(34);
    ɵngcc0.ɵɵpipe(35, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "div", 22);
    ɵngcc0.ɵɵelementStart(37, "label", 23);
    ɵngcc0.ɵɵtext(38);
    ɵngcc0.ɵɵpipe(39, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(40, "hr", 24);
    ɵngcc0.ɵɵelement(41, "fgbcl-short-long-description", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(42, LottoDetailsComponent_div_0_div_2_ng_template_42_Template, 30, 22, "ng-template", null, 26, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const entriesLimit_r2 = ctx.ngSubscribe;
    const _r6 = ɵngcc0.ɵɵreference(43);
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind3(3, 19, ctx_r1.lottoItem.ImageName, "7", "lotto"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("alt", ctx_r1.lottoItem.Title)("useDefault", true)("loyaltyType", "lotto");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.lottoItem.Title);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(13, 23, "lotto.details.points.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(17, 25, ctx_r1.lottoItem.PurchasePrice), " Pts");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(20, 27, "lotto.details.entries.count.screenreader"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.lottoItem.NumberOfTicketsPurchased == 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.lottoItem.NumberOfTicketsPurchased !== 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(26, 29, "lotto.details.countdown.screenreader"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("endDateTime", ctx_r1.lottoItem.EndDate);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.available);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", entriesLimit_r2 <= 0 || !ctx_r1.available || ctx_r1.entries > entriesLimit_r2 || entriesLimit_r2 > 0 && ctx_r1.entries < 1 || entriesLimit_r2 <= 0 && ctx_r1.entries < 0)("confirmContent", _r6)("termsAndCondtions", ctx_r1.lottoTerms);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(35, 31, ctx_r1.statusText), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(39, 33, "auction.description"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("description", ctx_r1.lottoItem.Description);
} }
function LottoDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelement(1, "fgbcl-errors");
    ɵngcc0.ɵɵtemplate(2, LottoDetailsComponent_div_0_div_2_Template, 44, 35, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngSubscribe", ctx_r0.entriesLimit$);
} }
class LottoDetailsComponent {
    constructor(errorService, router, lottosService, lottoQuery, balanceService, transactionSuccessService, balanceQuery) {
        this.errorService = errorService;
        this.router = router;
        this.lottosService = lottosService;
        this.lottoQuery = lottoQuery;
        this.balanceService = balanceService;
        this.transactionSuccessService = transactionSuccessService;
        this.balanceQuery = balanceQuery;
        this.entries = 1;
        this.available = false;
        this.LoyaltyLimitType = LoyaltyLimitType;
    }
    ngOnInit() {
        this.lottoItem = this.lottoQuery.getEntity(this.lottoId);
        if (this.lottoItem) {
            this.lottoTerms = new TermsAndCondtion(this.lottoItem.TermsAndConditions, this.lottoItem.ShowTermsAndConditions, this.lottoItem.TermsAndConditionsType);
        }
        this.entriesLimit$ = this.lottoQuery.selectEntriesLimit(this.lottoId);
        this.limitMessage$ = this.lottoQuery.selectEntriesLimitMessage(this.lottoId);
        this.setLottoStatus();
    }
    enterLotto() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.lottosService.enterLotto(this.lottoId, this.entries);
            const lotto = this.lottoQuery.getEntity(this.lottoId);
            let price = this.lottoQuery.getPrice(this.lottoId);
            if (price == undefined || lotto == undefined) {
                return;
            }
            const cost = price * this.entries;
            this.balanceService.debitBalance(config.purseConfig.virtualLoyalty, cost);
            this.transactionSuccessService.setTransaction(lotto, this.entries, cost);
            this.router.navigate(['/rewards/raffles/purchase/success']);
        });
    }
    lottoEnd() {
        this.router.navigate(['/rewards/raffles']);
    }
    setLottoStatus() {
        if (!this.lottoItem) {
            return;
        }
        // tslint:disable-next-line: no-bitwise
        if (this.lottoItem.AllowComingSoon === ItemLoyaltyState.ComingSoon) {
            this.statusText = 'lottos.coming.soon';
        }
        else if (this.lottoItem.ItemState === ItemLoyaltyState.OutOfStock) {
            this.statusText = 'lottos.sold.out';
        }
        else if (this.lottoItem.ItemState === ItemLoyaltyState.ItemLimitReached) {
            this.statusText = 'lottos.limit.reached';
        }
        else {
            this.balanceQuery
                .selectPurse(config.purseConfig.virtualLoyalty)
                .pipe(take(1))
                .subscribe((bal) => {
                let currentBal = bal !== null && bal !== void 0 ? bal : 0;
                if (this.lottoItem && currentBal < this.lottoItem.PurchasePrice) {
                    this.statusText = 'lottos.not.enough';
                }
                else {
                    this.statusText = 'lottos.enter.now';
                    this.available = true;
                }
            });
        }
    }
}
LottoDetailsComponent.ɵfac = function LottoDetailsComponent_Factory(t) { return new (t || LottoDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ErrorStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LottoService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LottoQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BalanceService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TransactionSuccessService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BalanceQuery)); };
LottoDetailsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LottoDetailsComponent, selectors: [["fgbcl-lotto-details"]], inputs: { lottoId: "lottoId" }, decls: 1, vars: 1, consts: [["class", "container", 4, "ngIf"], [1, "container"], ["class", "d-block d-lg-flex mt-lg-3 pt-lg-3", 4, "ngSubscribe"], [1, "d-block", "d-lg-flex", "mt-lg-3", "pt-lg-3"], [1, "loyalty-details-image", "card", "shadow", "border-0", "rounded-0", "overflow-hidden", "p-0"], ["draggable", "false", 1, "card-img", 3, "src", "alt", "useDefault", "loyaltyType"], [1, "card-img-overlay", "loyalty", "d-flex", "flex-column", "justify-content-start", "p-0"], ["loyaltyType", "lotto", 1, "corner-icon", "bg-lotto", "text-on-lotto"], [1, "loyalty-details", "w-100"], [1, "lotto-detail-name", "mt-0", "pl-0", "pl-lg-3", "pt-4", "pt-lg-0"], [1, "card-body", "d-flex", "flex-column", "justify-content-between", "pr-3", "pl-0", "pl-lg-3", "pb-4", "pt-2", "pt-lg-3"], [1, "row", "mb-2"], [1, "col-6", "col-lg-4", "d-flex", "align-items-center", "pb-3"], ["role", "img", 1, "icon", "material-icons", "lotto-icons-color", "mr-2"], [1, "font-size-18", "pt-1"], ["class", "font-size-18 pt-1", 4, "ngIf"], [1, "font-size-18", "pt-1", "countdown-color", 3, "endDateTime", "complete"], [1, "row", "ml-0", "pt-lg-4"], [1, "d-flex", "pl-0", "p-0"], [4, "ngIf"], [1, "d-flex", "mr-3"], ["confirmModalTerms", "", 1, "lotto-button", "btn", "font-weight-bold", "px-4", "mt-lg-0", 3, "disabled", "confirmContent", "termsAndCondtions", "confirm"], [1, "mb-2"], [1, "lotto-description-title", "pt-2", "pb-2", "pr-2", "pl-0", "mb-0", "mt-4", "mt-lg-5", "mr-3"], [1, "border-top", "border-disabled", "mt-0", "mb-2"], ["id", "description", 3, "description"], ["confirmContent", ""], ["class", "mb-3 mr-3 mb-lg-0 justify-content-center align-items-center", 4, "ngSubscribe"], [1, "mb-3", "mr-3", "mb-lg-0", "justify-content-center", "align-items-center"], ["theme", "lotto", 3, "isActive", "amount", "minValue", "maxValue", "incrementValue", "minMessage", "maxMessage", "amountChange"], [1, "text-center"], [1, "lotto-modal-title"], [1, "mt-0", "mx-5"], [1, "row", "my-5"], [1, "col-lg-2", "col-3", "d-flex", "justify-content-center"], ["draggable", "false", 1, "confirm-modal-image", "shadow", 3, "src", "alt", "useDefault", "loyaltyType"], [1, "col-lg-10", "col-9", "pl-0"], [1, "row"], [1, "col-12"], [1, "lotto-modal-item-name", "mb-1"], [1, "col-6"], [1, "lotto-modal-points-value", "mb-0"], [1, "font-weight-bold"], [1, "lotto-modal-entries", "mb-0"]], template: function LottoDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LottoDetailsComponent_div_0_Template, 3, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.lottoItem != undefined);
    } }, directives: [ɵngcc3.NgIf, ɵngcc4.ErrorsComponent, ɵngcc5.NgSubscribeDirective, ɵngcc5.ImgDefaultDirective, ɵngcc6.LoyaltyIconComponent, ɵngcc7.CountdownComponent, ɵngcc5.ConfirmModalTermsDirective, ɵngcc8.ShortLongDescriptionComponent, ɵngcc9.NumberInputComponent], pipes: [ɵngcc10.ContentImagePipe, ɵngcc11.TranslatePipe, ɵngcc3.DecimalPipe], styles: [""] });
LottoDetailsComponent.ctorParameters = () => [
    { type: ErrorStateService },
    { type: Router },
    { type: LottoService },
    { type: LottoQuery },
    { type: BalanceService },
    { type: TransactionSuccessService },
    { type: BalanceQuery }
];
LottoDetailsComponent.propDecorators = {
    lottoId: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LottoDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-lotto-details',
                template: "<div *ngIf=\"lottoItem != undefined\" class=\"container\">\r\n  <!-- Server Side Errors -->\r\n  <fgbcl-errors></fgbcl-errors>\r\n\r\n  <div class=\"d-block d-lg-flex mt-lg-3 pt-lg-3\" *ngSubscribe=\"entriesLimit$ as entriesLimit\">\r\n    <!-- Image -->\r\n    <div class=\"loyalty-details-image card shadow border-0 rounded-0 overflow-hidden p-0\">\r\n      <img\r\n        class=\"card-img\"\r\n        src=\"{{ lottoItem.ImageName | contentImage: '7':'lotto' }}\"\r\n        [alt]=\"lottoItem.Title\"\r\n        [useDefault]=\"true\"\r\n        [loyaltyType]=\"'lotto'\"\r\n        draggable=\"false\"\r\n      />\r\n      <div class=\"card-img-overlay loyalty d-flex flex-column justify-content-start p-0\">\r\n        <fgbcl-loyalty-icon class=\"corner-icon bg-lotto text-on-lotto\" loyaltyType=\"lotto\"></fgbcl-loyalty-icon>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Details -->\r\n    <div class=\"loyalty-details w-100\">\r\n      <h2 class=\"lotto-detail-name mt-0 pl-0 pl-lg-3 pt-4 pt-lg-0\">{{ lottoItem.Title }}</h2>\r\n      <!-- Card Body -->\r\n      <div class=\"card-body d-flex flex-column justify-content-between pr-3 pl-0 pl-lg-3 pb-4 pt-2 pt-lg-3\">\r\n        <!-- Item Details -->\r\n        <div class=\"row mb-2\">\r\n          <!-- Points -->\r\n          <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\">\r\n            <span\r\n              class=\"icon material-icons lotto-icons-color mr-2\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'lotto.details.points.screenreader' | translate }}\"\r\n              >emoji_events</span\r\n            >\r\n            <span class=\"font-size-18 pt-1\">{{ lottoItem.PurchasePrice | number }} Pts</span>\r\n          </div>\r\n          <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\">\r\n            <span\r\n              class=\"icon material-icons lotto-icons-color mr-2\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'lotto.details.entries.count.screenreader' | translate }}\"\r\n              >confirmation_number</span\r\n            >\r\n            <span *ngIf=\"lottoItem.NumberOfTicketsPurchased == 1\" class=\"font-size-18 pt-1\"\r\n              >{{ lottoItem.NumberOfTicketsPurchased }} Entry</span\r\n            >\r\n            <span *ngIf=\"lottoItem.NumberOfTicketsPurchased !== 1\" class=\"font-size-18 pt-1\"\r\n              >{{ lottoItem.NumberOfTicketsPurchased }} Entries</span\r\n            >\r\n          </div>\r\n          <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\">\r\n            <span\r\n              class=\"icon material-icons lotto-icons-color mr-2\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'lotto.details.countdown.screenreader' | translate }}\"\r\n              >schedule</span\r\n            >\r\n            <fgbcl-countdown\r\n              class=\"font-size-18 pt-1 countdown-color\"\r\n              [endDateTime]=\"lottoItem.EndDate\"\r\n              (complete)=\"lottoEnd()\"\r\n            ></fgbcl-countdown>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Bottom Buttons -->\r\n        <div class=\"row ml-0 pt-lg-4\">\r\n          <div class=\"d-flex pl-0 p-0\">\r\n            <ng-container *ngIf=\"available\">\r\n              <div\r\n                class=\"mb-3 mr-3 mb-lg-0 justify-content-center align-items-center\"\r\n                *ngSubscribe=\"limitMessage$ as limitMessage\"\r\n              >\r\n                <fgbcl-number-input\r\n                  [isActive]=\"available\"\r\n                  [(amount)]=\"entries\"\r\n                  [minValue]=\"entriesLimit > 0 ? 1 : 0\"\r\n                  [maxValue]=\"entriesLimit\"\r\n                  [incrementValue]=\"1\"\r\n                  [minMessage]=\"'1 minimum'\"\r\n                  [maxMessage]=\"limitMessage | translate\"\r\n                  theme=\"lotto\"\r\n                >\r\n                </fgbcl-number-input>\r\n              </div>\r\n            </ng-container>\r\n            <div class=\"d-flex mr-3\">\r\n              <button\r\n                [disabled]=\"\r\n                  entriesLimit <= 0 ||\r\n                  !available ||\r\n                  entries > entriesLimit ||\r\n                  (entriesLimit > 0 && entries < 1) ||\r\n                  (entriesLimit <= 0 && entries < 0)\r\n                \"\r\n                class=\"lotto-button btn font-weight-bold px-4 mt-lg-0\"\r\n                confirmModalTerms\r\n                [confirmContent]=\"confirmContent\"\r\n                [termsAndCondtions]=\"lottoTerms\"\r\n                (confirm)=\"enterLotto()\"\r\n              >\r\n                {{ statusText | translate }}\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Description & Terms  -->\r\n        <div class=\"mb-2\">\r\n          <label class=\"lotto-description-title pt-2 pb-2 pr-2 pl-0 mb-0 mt-4 mt-lg-5 mr-3\">{{\r\n            'auction.description' | translate\r\n          }}</label>\r\n          <hr class=\"border-top border-disabled mt-0 mb-2\" />\r\n          <fgbcl-short-long-description id=\"description\" [description]=\"lottoItem.Description\"> </fgbcl-short-long-description>\r\n        </div>\r\n\r\n        <!-- Confirm Modal Content -->\r\n        <ng-template #confirmContent>\r\n          <p class=\"text-center\">\r\n            <b class=\"lotto-modal-title\">{{ 'lotto.confirm.text' | translate }}</b>\r\n          </p>\r\n          <hr class=\"mt-0 mx-5\" />\r\n          <div class=\"row my-5\">\r\n            <div class=\"col-lg-2 col-3 d-flex justify-content-center\">\r\n              <img\r\n                class=\"confirm-modal-image shadow\"\r\n                src=\"{{ lottoItem.ImageName | contentImage: '7':'lotto' }}\"\r\n                alt=\"{{ lottoItem.ImageName }}\"\r\n                [useDefault]=\"true\"\r\n                [loyaltyType]=\"'lotto'\"\r\n                draggable=\"false\"\r\n              />\r\n            </div>\r\n            <div class=\"col-lg-10 col-9 pl-0\">\r\n              <div class=\"row\">\r\n                <div class=\"col-12\">\r\n                  <div class=\"lotto-modal-item-name mb-1\">{{ lottoItem.Title }}</div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col-6\">\r\n                  <div class=\"lotto-modal-points-value mb-0\">\r\n                    <span class=\"font-weight-bold\">{{ 'lotto.points.value' | translate }}</span>\r\n                    <span> {{ lottoItem.PurchasePrice * entries | number }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-6\">\r\n                  <div class=\"lotto-modal-entries mb-0\">\r\n                    <span class=\"font-weight-bold\">{{ 'lotto.entries' | translate }}</span>\r\n                    <span> {{ entries }}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.ErrorStateService }, { type: ɵngcc2.Router }, { type: ɵngcc1.LottoService }, { type: ɵngcc1.LottoQuery }, { type: ɵngcc1.BalanceService }, { type: ɵngcc1.TransactionSuccessService }, { type: ɵngcc1.BalanceQuery }]; }, { lottoId: [{
            type: Input
        }] }); })();

class LottoDetailsModule {
}
LottoDetailsModule.ɵfac = function LottoDetailsModule_Factory(t) { return new (t || LottoDetailsModule)(); };
LottoDetailsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LottoDetailsModule });
LottoDetailsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ErrorsModule,
            LoyaltyIconModule,
            CountdownModule,
            NumberInputModule,
            PipesModule,
            ShortLongDescriptionModule,
            DirectivesModule,
            ConfirmModalTermsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LottoDetailsModule, { declarations: function () { return [LottoDetailsComponent]; }, imports: function () { return [CommonModule,
        ErrorsModule,
        LoyaltyIconModule,
        CountdownModule,
        NumberInputModule,
        PipesModule,
        ShortLongDescriptionModule,
        DirectivesModule,
        ConfirmModalTermsModule, ɵngcc11.TranslateModule]; }, exports: function () { return [LottoDetailsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LottoDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [LottoDetailsComponent],
                imports: [
                    CommonModule,
                    ErrorsModule,
                    LoyaltyIconModule,
                    CountdownModule,
                    NumberInputModule,
                    PipesModule,
                    ShortLongDescriptionModule,
                    DirectivesModule,
                    ConfirmModalTermsModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [LottoDetailsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LottoDetailsComponent, LottoDetailsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-lottos-lotto-details.js.map